import React, { useState } from 'react';
import { FileTemplateExport, IcoFileGraph, ExclamationRed, ConfirmSolid } from '@icons';
import { Button, Modal } from 'react-bootstrap';
import DownloadTrackRecordButton from './DownloadTrackRecordButton';
import { OETrans } from 'components/translation/OETrans';

const ExportTrackRecordModal = ({ aggregateId, trackRecords }) => {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [successMessageReport, setSuccessMessageReport] = useState('');
	const [result, setResult] = useState('');

	const handleClose = () => {
		setIsModalOpen(false);
		setTimeout(() => {
			setSuccessMessageReport('');
			setResult('');
		}, 300);
	};

	//TEST
	/* trackRecords = [
		{
			id: 1,
			name: 'primo-track',
			file: '/INFRATEL/TRACKRECORDS/B27G21000180004/primo-track.xlsx',
			log: null,
			projectaggregateId: 10,
			firstExport: 1,
			createdAt: '2025-11-07T11:42:24.000000Z',
			updatedAt: '2025-11-07T12:43:27.000000Z',
		},
		{
			id: 2,
			name: 'secondo-track',
			file: '/INFRATEL/TRACKRECORDS/B27G21000180005/secondo-track.xlsx',
			log: null,
			projectaggregateId: 10,
			firstExport: 1,
			createdAt: '2025-11-07T11:42:24.000000Z',
			updatedAt: '2025-11-07T12:43:27.000000Z',
		},
		{
			id: 3,
			name: 'terzo-track',
			file: '/INFRATEL/TRACKRECORDS/B27G21000180006/terzo-track.xlsx',
			log: null,
			projectaggregateId: 10,
			firstExport: 1,
			createdAt: '2025-11-07T11:42:24.000000Z',
			updatedAt: '2025-11-07T12:43:27.000000Z',
		},
	]; */
	//console.log('trackRecords', trackRecords);

	return (
		<>
			<Button
				className="btn custom-primary-button d-flex justify-content-center align-items-center gap-2"
				style={{
					width: '155px',
					height: '48px',
					fontWeight: 500,
				}}
				onClick={() => setIsModalOpen(true)}
			>
				<IcoFileGraph className="ico-path-fill-white" style={{ verticalAlign: 'text-top' }} /> Esporta
			</Button>

			<Modal
				show={isModalOpen}
				onHide={() => {
					handleClose();
				}}
				centered
				size="lg"
				className="custom-scrollable_body-modal"
			>
				{result ? (
					result === 'success' ? (
						<>
							<Modal.Body>
								<div className="text-center mb-4" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
									<ConfirmSolid className="mt-3 d-block" style={{ width: '40px' }} />
									<span className="mt-4 d-block f-700" style={{ fontSize: '24px' }}>
										Perfetto!
									</span>
									<span className="mt-3 d-block f-400">{successMessageReport}</span>
								</div>
							</Modal.Body>
							<Modal.Footer className="justify-content-center">
								<Button className="new custom-primary-button w-100" style={{ fontWeight: '500' }} onClick={() => handleClose()}>
									<OETrans code="common.close" fallback={'Chiudi'} />
								</Button>
							</Modal.Footer>
						</>
					) : (
						<>
							<Modal.Body className="text-center">
								<div className="text-center mb-4" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
									<ExclamationRed className="mt-3 d-block" />
									<span className="mt-4 d-block f-700" style={{ fontSize: '24px' }}>
										Errore imprevisto
									</span>
									<span className="mt-4 d-block f-400">Si è verificato un errore durante la generazione del report.</span>
									<span className="mt-4 d-block f-400">
										Ti preghiamo di riprovare più tardi o contattare l'amministratore di sistema se il problema persiste.
									</span>
								</div>
							</Modal.Body>
							<Modal.Footer className="justify-content-center">
								<Button className="new custom-primary-button w-100" style={{ fontWeight: '500' }} onClick={() => handleClose()}>
									<OETrans code="common.close" fallback={'Chiudi'} />
								</Button>
							</Modal.Footer>
						</>
					)
				) : (
					<>
						<Modal.Header style={{ justifyContent: 'center', padding: '1.5rem' }}>
							<Modal.Title style={{ display: 'grid', gap: '1rem', justifyItems: 'center' }}>
								<FileTemplateExport
									style={{
										fill: 'var(--np-text-primary-color)',
									}}
								/>
								<h5 style={{ fontSize: '24px', fontWeight: 700, marginBottom: 0 }}>Esporta</h5>
								<p style={{ fontSize: '18px', fontWeight: 400, marginBottom: 0 }}>Scegli ciò di cui hai bisogno.</p>
							</Modal.Title>
						</Modal.Header>

						<Modal.Body style={{ display: 'grid', gap: '1rem', overflowY: 'auto' }}>
							{trackRecords && trackRecords.length > 0 ? (
								trackRecords.map((track) => (
									<div
										key={track.id}
										style={{
											borderRadius: '8px',
											padding: '1rem',
											border: '1px solid #2A3A64',
											display: 'grid',
											gap: '3em',
											gridTemplateColumns: '1fr auto',
										}}
									>
										<div style={{ display: 'grid', gap: '0.5rem' }}>
											<p style={{ marginBottom: 0, fontWeight: 700 }}>Track record</p>
											<p style={{ marginBottom: 0 }}>{track.name}</p>
										</div>
										<div style={{ display: 'grid', placeContent: 'center' }}>
											<DownloadTrackRecordButton
												aggregateId={aggregateId}
												trackRecordId={track.id}
												setSuccessMessageReport={setSuccessMessageReport}
												setResult={setResult}
											/>
										</div>
									</div>
								))
							) : (
								<div className="text-center py-5">Nessun track record disponibile per l'esportazione.</div>
							)}
						</Modal.Body>

						<Modal.Footer>
							<Button
								className="btn custom-outline-button"
								style={{
									height: '48px',
								}}
								onClick={() => {
									handleClose();
								}}
							>
								Annulla
							</Button>
						</Modal.Footer>
					</>
				)}
			</Modal>
		</>
	);
};

export default ExportTrackRecordModal;
